// Save the original fetch function
const originalFetch = window.fetch;

// Override fetch to automatically add the header
window.fetch = (url, options = {}) => {
    // Ensure that `options.headers` is correctly initialized
    options.headers = {
        ...options.headers,
        'X-Requested-With': 'XMLHttpRequest'
    };

    // Call the original fetch with the added header
    return originalFetch(url, options);
};